export default __webpack_public_path__ + "static/media/tubeCut.e292d88d.svg";